var STROKE = 'stroke',
    DASH = STROKE + '-dash', // stoke-width
    DASH_ARRAY = DASH + 'array'

module.exports = {
    opacity: STROKE + '-opacity',
    width: STROKE + '-width',
    offset: DASH + 'offset',
    length: DASH_ARRAY,
    spacing: DASH_ARRAY,
    miterlimit: STROKE + '-miterlimit'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/path/lookup.js
 ** module id = 48
 ** module chunks = 0
 **/